import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { fetchPublicCalendar, publicCalendarQueryKey } from '../features/client-calendar/api.js';
import { ClientCalendarView } from '../features/client-calendar/client-calendar-view.js';

function ClientCalendarPage() {
  const { token } = Route.useParams();
  const [period, setPeriod] = useState<{ year: number; month: number } | null>(null);
  const calendar = useQuery({
    queryKey: publicCalendarQueryKey(token, period?.year, period?.month),
    queryFn: () => fetchPublicCalendar(token, period?.year, period?.month),
    retry: false,
  });

  if (calendar.isLoading) {
    return (
      <main className="min-h-screen bg-[var(--bg)] p-8">
        <p className="text-center text-[var(--fg-2)]">Betöltés…</p>
      </main>
    );
  }

  if (calendar.isError || !calendar.data) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-[var(--bg)] p-6">
        <div className="max-w-md rounded-lg border border-[var(--app-divider)] bg-[var(--n-0)] p-8 text-center shadow-1">
          <h1 className="text-h2 font-semibold text-[var(--ink-700)]">
            Érvénytelen vagy visszavont link
          </h1>
          <p className="mt-2 text-body text-[var(--fg-2)]">
            A naptár-link nem érvényes vagy vissza lett vonva. Kérjen új linket a kampányfelelőstől.
          </p>
        </div>
      </main>
    );
  }

  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <ClientCalendarView
        data={calendar.data}
        token={token}
        onMonthChange={(year, month) => setPeriod({ year, month })}
      />
    </div>
  );
}

export const Route = createFileRoute('/calendar/$token')({
  component: ClientCalendarPage,
});
